import { FileExtendedDetails } from 'sos-common/js/commonTypes/fileupload.types';
import { clientError } from 'sos-common/js/commonTypes/ClientError.types'

export const API_ENDPOINT_FRIVILLIG = '/_api/sbgfrivillig';
export const API_ENDPOINT_REQUIRED = '/_api/sbgrequired';

export interface StatsbidragCompletionProps {
    isRequiredCompletion?: boolean;
    expandHeading: string;
    expandIcon?: string;
    expandCssClass?: string;
    fileHeading: string; 
    innerHeading?: string;
    innerParagraph?: string;
    caseId: string;
    type: string;
    documentList?: StatsbidragCompletionDocumentListItem[];
    complementaryId?: string;
  }

  export interface StatsbidragCompletionState {
    unlockSendButton: boolean;
    fileUploadState: FileExtendedDetails[]; 
    serverResponseObject: PostFilesServerResponseObject;
    complementaryId: string;
    clientError: clientError;
    showDialog: boolean;
    sendSuccess: boolean;
    sendCompletionErrorMessage: string;
  }

  export interface StatsbidragCompletionDocumentListItem {
      fileName: string;
      url: string;
      fileExtension: string;
      fileId: string;
  }

  export interface GetAttachmentsServerResponseObject {
    Files: ServerResponseFile[];
    CompletionId: string;
  }

  export interface PostFilesServerResponseObject {
    FileId: string;
    ComplementaryId: string;
    OriginalFilename: string;
  }
  
  export interface ServerResponseFile {
    Filnamn: string;
    Id: string;
    MimeType: string;
    Langd: number;
    SkapadTidpunkt: string;
  }